export const DEFAULT_LANGUAGE = 'en';
export const EN = 'en';
export const DE = 'de';
